<div class="row justify-content-center my-3">
    <div class="col-lg-5">
        <div class="card bg-light shadow border-0">
            <div class="card-body px-lg-5 py-lg-5">
                <div class="text-center">
                    <h4>Your account created successfully</h4>
                    <p>Please check your email Inbox and click the link to verify and sign in to fill your application.
                    </p>
                    <div class="d-flex justify-content-between align-items-center my-3">
                        <a class="btn btn-primary" [routerLink]="['/account/login']">
                            <span class="mr-2">
                                <i-bs name="chevron-left" width="1em" height="1em"></i-bs>
                            </span>Return to login</a>
                        <a [routerLink]="['/account/resend-confirm-link']"
                            class="link-dark text-decoration-none fw-bold">
                            Resend Confirmation Link
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>